import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../../../store';
import IgniteDataTable from '../../../../common/datatable';
import ConfirmPopup from '../../../../common/confirm-popup';
import { deletePromotionalBanner } from '../../../../../actions/promotional_banners';
import { dateFormat } from "../../../../../utils/commonFunctions";
import PropTypes from 'prop-types';

const columns = [
  { prop: 'name', title: 'Name' },
  { prop: 'groups-names', title: 'Group(s)' },
  {
    prop: 'display-from-date',
    title: 'Display from date',
    format: date => dateFormat(date)
  },
  {
    prop: 'display-to-date',
    title: 'Display to date',
    format: date => dateFormat(date)
  },
];

class PromotionalBannersList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const { dispatch } = this.props;
    const { id } = this.state.delete;

    this.setState({ delete: { show: false } });

    if (result) {
      dispatch(deletePromotionalBanner(id));
    }
  };

  render() {
    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'PromotionalBanner'
        },
        callback: (row) => {
          history.push(`/admin/promotional_banners/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'PromotionalBanner'
        },
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    const {promotional_banners} = this.props;
    const {delete: { show }} = this.state;

    return (
      <div>
        <IgniteDataTable
          data={promotional_banners}
          columns={columns}
          actions={actions}
          pagination={{
            sizePerPage:  20,
          }}
        />
        {
          show &&
          <ConfirmPopup
            header="DELETE PROMOTIONAL_BANNER?"
            onClose={this.handleDelete}
          >
            <p>Are you sure you want to delete this promotional banner?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

PromotionalBannersList.propTypes = {
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  promotional_banners: PropTypes.array.isRequired,
};

export default connect()(PromotionalBannersList)



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotional_banners/list/promotional-banner-list.jsx